"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getEffect", {
  enumerable: true,
  get: function get() {
    return _getEffect["default"];
  }
});
Object.defineProperty(exports, "getEvents", {
  enumerable: true,
  get: function get() {
    return _getEvents["default"];
  }
});

var _getEffect = _interopRequireDefault(require("./getEffect"));

var _getEvents = _interopRequireDefault(require("./getEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }